/*
 *
 * ActionPlansImport actions
 *
 */

import {
  DEFAULT_ACTION,
  GET_TEMPLATE_WATCHER,
  GET_TEMPLATE_SUCCESS,
  GET_TEMPLATE_FAILED,
  UPLOAD_TEMPLATE_WATCHER,
  UPLOAD_TEMPLATE_SUCCESS,
  UPLOAD_TEMPLATE_FAILED,
} from "./constants"

export function defaultAction() {
  return { type: DEFAULT_ACTION }
}

// GET TEMPLATE
export function getTemplate(payload) {
  return {
    type: GET_TEMPLATE_WATCHER,
    payload,
  }
}

export function getTemplateSuccess(payload) {
  return {
    type: GET_TEMPLATE_SUCCESS,
    payload,
  }
}

export function getTemplateFailed(payload) {
  return { type: GET_TEMPLATE_FAILED }
}

// UPLOAD TEMPLATE
export function uploadTemplate(payload) {
  return {
    type: UPLOAD_TEMPLATE_WATCHER,
    payload,
  }
}

export function uploadTemplateSuccess(payload) {
  return {
    type: UPLOAD_TEMPLATE_SUCCESS,
    payload,
  }
}

export function uploadTemplateFailed(payload) {
  return {
    type: UPLOAD_TEMPLATE_FAILED,
    payload,
  }
}
